import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Box, Breadcrumbs, Button, TextField, Typography } from '@mui/material';
import AppShell from './components/AppShell';
import api from './services/api';

const AddSurvey = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [alchemerId, setAlchemerId] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post(`/projects/${projectId}/surveys/`, {
        name,
        alchemer_survey_id: parseInt(alchemerId, 10),
      });
      navigate(`/project/${projectId}`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create survey.');
    }
  };

  return (
    <AppShell maxWidth="sm">
      <Breadcrumbs separator=">" sx={{ mb: 3 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Home</Link>
        <Link to={`/project/${projectId}`} style={{ textDecoration: 'none', color: 'inherit' }}>Project</Link>
        <Typography color="textPrimary">Add Survey</Typography>
      </Breadcrumbs>

      <Box
        sx={{
          bgcolor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 3,
          p: 4,
        }}
      >
        <Typography variant="h5" fontFamily="'Work Sans', sans-serif" fontWeight={700} gutterBottom>
          Add Survey Wave
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Survey name (e.g. Wave 1 Q1 2026)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            fullWidth
          />
          <TextField
            label="Alchemer Survey ID (7 digits)"
            value={alchemerId}
            onChange={(e) => setAlchemerId(e.target.value)}
            required
            fullWidth
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]{7}' }}
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button
            type="submit"
            variant="contained"
            sx={{ borderRadius: 2, textTransform: 'none', py: 1.2 }}
          >
            Add Survey
          </Button>
        </Box>
      </Box>
    </AppShell>
  );
};

export default AddSurvey;
